// Copy a conversation's name / a person's @username (PARITY P326): the conversation row's menu
// (right-click / long-press) says what it copies — «Copiar nombre», and on a DM also «Copiar @usuario»
// (the profile card already has that one). The old item showed the NAME itself as its label, which
// read as a heading, not a verb (menu verbs name their object).
import { useContext } from 'react';
import type { DisplayChannel } from '../../../core/channelListDisplayModels';
import { Icon } from '../../../design/icons';
import { t } from '../../../i18n/i18n';
import { ShellContext } from '../../shell/ShellContext';

async function copy(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export function CopyNameItems({ row, onDone }: { row: DisplayChannel; onDone(): void }) {
  const shell = useContext(ShellContext);
  const say = (ok: boolean, done: string) => shell?.toast(ok ? done : t('web.extras.copyFailed'), ok ? 'info' : 'error');
  const username = row.type === 'D' ? row.dmPartnerUsername : null;
  return (
    <>
      <button
        className="menu-item"
        role="menuitem"
        data-menu="copy-name"
        onClick={() => {
          onDone();
          void copy(row.name).then((ok) => say(ok, t('web.extras.nameCopied')));
        }}
      >
        <Icon name="copy" size={16} /> {t('web.extras.copyName')}
      </button>
      {username ? (
        <button
          className="menu-item"
          role="menuitem"
          data-menu="copy-username"
          onClick={() => {
            onDone();
            void copy('@' + username).then((ok) => say(ok, t('web.extras.usernameCopied')));
          }}
        >
          <Icon name="at" size={16} /> {t('web.people.profile.copyUsername')}
        </button>
      ) : null}
    </>
  );
}
